import React, { ReactElement, useContext, Suspense, lazy, ComponentType } from 'react';
import { DistributorDataContext, IDistributorDataTypeState } from 'context/DistributorData';
// import { ClaimLookup } from 'components/pages/ClaimLookup/ClaimLookup';

// Lazy load components for code splitting
const ClaimLookup = lazy(() => import('./ClaimLookup').then((module) => ({ default: module.ClaimLookup })));
const AdvantageClaimLookup = lazy(() =>
    import('components/pages/AdvantageClaimLookup').then((module) => ({ default: module.AdvantageClaimLookup }))
);
// Map distributor keys to their custom Claim Lookup components
const DISTRIBUTOR_CLAIM_LOOKUP_COMPONENTS: Record<string, React.LazyExoticComponent<ComponentType<any>>> = {
    advantage: AdvantageClaimLookup
    // Add more distributors here as needed, e.g.:
    // 'partner-x': ClaimLookupPartnerX,
};
const ClaimLookupRouter = (): ReactElement | null => {
    const distributorContext = useContext(DistributorDataContext) as IDistributorDataTypeState | null;
    const distributorKey = distributorContext?.contextStateDistributorData?.distributorKey ?? '';
    const ClaimLookupComponent = DISTRIBUTOR_CLAIM_LOOKUP_COMPONENTS[distributorKey] ?? ClaimLookup;

    console.info(
        '\n::::::::::::::::::::::::::::::::ClaimLookup:::::::::::::::::::::::::::::::::',
        '\n::DistributorDataContext::',
        DistributorDataContext,
        '\n::distributorContext?.contextStateDistributorData?.distributorKey::',
        distributorContext?.contextStateDistributorData?.distributorKey,
        '\n:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::'
    );
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <ClaimLookupComponent key={distributorKey} />
        </Suspense>
    );
};

export { ClaimLookupRouter };
